export default "__VITE_ASSET__Ckw9kiqT__"